import React from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import Wrapper from "../atoms/Wrapper";
import VTuberStream from "./VTuberStream";
import {
  get_related_vtubers,
  reset_related_vtubers
} from "../../actions/vtuber";

const StyledWrapper = styled(Wrapper)`
  flex-direction: column;
  width: 95%;
  align-items: flex-start;
  box-sizing: border-box;
`;

const RelatedVTuberStream = props => {
  const dispatch = useDispatch();
  const { page, state, items, has_more } = useSelector(
    state => state.vtuber.related
  );
  const loadMore = page => {
    dispatch(get_related_vtubers(props.vtuber_id)(page));
  };

  React.useEffect(() => {
    return () => dispatch(reset_related_vtubers());
  }, [dispatch, props.vtuber_id]);

  return (
    <StyledWrapper>
      <VTuberStream
        items={items}
        loadMore={loadMore}
        page={page}
        hasMore={has_more}
        requestState={state}
        style={{ justifyContent: "center" }}
      />
    </StyledWrapper>
  );
};

export default RelatedVTuberStream;
